module.exports = __webpack_public_path__ + "img/900038785.8109704d.png";